module.exports = __webpack_public_path__ + "static/media/tarot-card-2.4b35a2b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/tarotcards/tarot-card-2.jpg
// module id = 142
// module chunks = 0